import React from 'react';

function uniqueStops(locations) {
   const seen = new Set();
   const out = [];
   (locations || []).forEach((l) => {
      const key = l.id != null ? `id:${l.id}` : `ord:${l.locationOrder}-${l.dealershipId ?? ''}`;
      if (seen.has(key)) {
         return;
      }
      seen.add(key);
      out.push(l);
   });
   return out.sort((a, b) => (a.locationOrder ?? 0) - (b.locationOrder ?? 0));
}

function locationsFromVehicles(vehicles) {
   const locs = [];
   (vehicles || []).forEach((v) => {
      if (v.TripLocation) {
         locs.push(v.TripLocation);
      }
      if (v.TripLocation1) {
         locs.push(v.TripLocation1);
      }
   });
   return uniqueStops(locs);
}

export function tripRouteStops(trip, vehicles) {
   const mine = vehicles || [];
   const locs = uniqueStops([
      ...(trip?.TripLocations || []),
      ...(!(trip?.TripLocations?.length) ? locationsFromVehicles(trip?.TripVehicles) : []),
   ]);

   const isMine = (loc) => mine.some((v) => {
      const from = v.TripLocation;
      const to = v.TripLocation1;
      if (from?.id && loc.id === from.id) {
         return true;
      }
      if (to?.id && loc.id === to.id) {
         return true;
      }
      if (from?.locationOrder != null && loc.locationOrder === from.locationOrder) {
         return true;
      }
      if (to?.locationOrder != null && loc.locationOrder === to.locationOrder) {
         return true;
      }
      return false;
   });

   const stopLabel = (loc) => {
      const d = loc?.Dealership;
      if (!d?.city) {
         return '';
      }
      return d.stateAbbr ? `${d.city}, ${d.stateAbbr}` : d.city;
   };

   if (locs.length) {
      return locs
         .map((l, i) => {
            const label = stopLabel(l);
            return {
               key: String(l.id ?? i),
               label,
               mine: label ? isMine(l) : false,
            };
         })
         .filter((s) => s.label);
   }

   const dealerLabel = (d) => {
      if (!d?.city) {
         return '';
      }
      return d.stateAbbr ? `${d.city}, ${d.stateAbbr}` : d.city;
   };

   const from = dealerLabel(trip?.Dealership2);
   const to = dealerLabel(trip?.Dealership1);
   if (from && to) {
      return [
         { key: 'from', label: from, mine: mine.length > 0 },
         { key: 'to', label: to, mine: mine.length > 0 },
      ];
   }
   if (from) {
      return [{ key: 'from', label: from, mine: mine.length > 0 }];
   }
   if (to) {
      return [{ key: 'to', label: to, mine: mine.length > 0 }];
   }
   return [];
}

export function renderTripRoute(trip, vehicles) {
   const stops = tripRouteStops(trip, vehicles);
   if (!stops.length) {
      return 'Route not specified';
   }
   return stops.map((s, i) => (
      <span key={s.key}>
         {i > 0 ? <span className="job-card-route-arrow"> → </span> : null}
         <span className={s.mine ? 'job-card-route-mine' : undefined}>{s.label}</span>
      </span>
   ));
}
